import React, { useState } from "react";

import "../../resources/css/vyg.css";
import loginImage from "../../resources/images/vyoog.png";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button
} from "@mui/material";

import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import {
  Face6 as AccountCircle,
  Password as PasswordIcon,
  CorporateFare as CorporateFareIcon,
  NextPlan as NextPlanIcon,
  VerifiedUser as VerifiedUserIcon,
  Badge as BadgeIcon,
} from "@mui/icons-material";



const Signup = ({ signupVisible, enableSignUpPage }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [gmailUserNameVisible, setGmailUserNameVisible] = useState("");
  const responseMessage = (response) => {
    const USER_CREDENTIAL = jwtDecode(response.credential);
    setGmailUserNameVisible(USER_CREDENTIAL.name);
    setPasswordVisible(true);
  };

  return (
    <div>
      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item xs={11} sm={8} md={2} lg={6}>
          <Card style={{ padding: "20px" }}>
            <CardContent>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={8} md={2} lg={6}>
                  <img
                    src={loginImage}
                    alt="Login"
                    style={{ width: "55%", marginBottom: "1rem" }}
                  />

                  <Typography sx={{ fontSize: 20 }} gutterBottom>
                    <br />
                    Register to <br />
                  </Typography>
                  <Typography
                    variant="h3"
                    component="div" 
                    color="text.secondary"
                  >
                    EIS
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={8} md={2} lg={6}>
                  {gmailUserNameVisible && (
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Hey <AccountCircle style={{ verticalAlign: "middle" }} />{" "}
                      <h3>{gmailUserNameVisible}</h3>
                    </Typography>
                  )}

                  {!passwordVisible && (
                    <Grid container spacing={5}>
                      <Grid item xs={12} sm={8} md={2} lg={12}>
                        <TextField
                          id="standard-basic"
                          label="Email Address"
                          variant="standard"
                          type="email"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "0.5rem",
                                }}
                              >
                                <AccountCircle />
                              </Box>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={8} md={2} lg={6}>
                        <TextField
                          id="standard-basic"
                          label="Full Name"
                          variant="standard"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "0.5rem",
                                }}
                              >
                                <BadgeIcon />
                              </Box>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={8} md={12} lg={6}>
                        <TextField
                          type="password"
                          id="standard-basic"
                          label="Password"
                          variant="standard"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "0.5rem",
                                }}
                              >
                                <PasswordIcon />
                              </Box>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {!passwordVisible && (
                    <div>
                      <br />
                      <br />
                      <br />
                      <Button
                        variant="contained"
                        onClick={() => setPasswordVisible((prev) => !prev)}
                        color="warning"
                        startIcon={<NextPlanIcon />}
                        style={{ width: "100%" }}
                      >
                        Next
                      </Button>
                    </div>
                  )}

                  {passwordVisible && (
                    <div>
                      <br />
                      <TextField
                        id="standard-basic"
                        label="Enter Organization"
                        variant="standard"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "0.5rem",
                              }}
                            >
                              <CorporateFareIcon />
                            </Box>
                          ),
                        }}
                      />

                      <br />
                      <br />
                      <br />
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<VerifiedUserIcon />}
                        style={{ width: "100%" }}
                      >
                        Signup
                      </Button>
                    </div>
                  )}

                  <br />
                  <br />

                  <div className={`signup-field ${passwordVisible && "hide"}`}>
                    <center>
                      <Typography
                        sx={{ fontSize: 12 }}
                        color="text.secondary"
                        gutterBottom
                      >
                        Or Signup With
                      </Typography>
                      <br />
                      <GoogleOAuthProvider clientId="1038184094845-70foh19lm7fo0nvbb8587ov3o5bejgrq.apps.googleusercontent.com">
                        <GoogleLogin onSuccess={responseMessage} />
                      </GoogleOAuthProvider>
                    </center>
                    <br />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Signup;
